import { autoinject, bindable, bindingMode } from "aurelia-framework";

import { Template } from "../../../models/template";

@autoinject
export class TemplateForm {
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public template: Template;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public isLoading: boolean = false;
    public keywords: string[] = [
        "<Patient Address>",
        "<Date of Birth>",
        "<Patient Name>",
        "<Terminal Diagnosis>",
        "<Hospice Physician>",
        "<Attending Physician>",
        "<Bereaved Contact>",
        "<Bereaved Contact Address>",
        "<Bereaved Contact Phone Number>",
        "<Referral Source>",
        "<Date of Death>",
        "<Date of Admission>"
    ];
}
